import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Pagination } from '@components/Pagination';
import { TOAST_AUTO_CLOSE_TIME } from '@shared/constants';
import { Wrapper, PaginationWrapper, MainTitlePage, TotalCountUser } from './styles';
import { fetchStaff, putStaffOffset, fetchCountStaff, putStaffPageNumber } from './actions';
import { staffListOffset } from './helpers';
import { DEFAULT_PAGE_NUMBER, DEFAULT_OFFSET } from './consts';
import { StaffSortableTable } from './components/StaffSortableTable';

export const StaffList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, error, count, list, pageNumber } = useSelector((state: any) => state.getIn(['staffList']).toJS());

  const changePage = useCallback(
    (page: number) => {
      dispatch(putStaffPageNumber(page));
      dispatch(putStaffOffset(staffListOffset * (page - 1)));
      dispatch(fetchStaff());
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(fetchStaff());
    dispatch(fetchCountStaff());
    return () => {
      dispatch(putStaffPageNumber(DEFAULT_PAGE_NUMBER));
      dispatch(putStaffOffset(DEFAULT_OFFSET));
    };
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(t('Informative.Negative.usersNotLoad'), {
        autoClose: TOAST_AUTO_CLOSE_TIME,
        position: 'bottom-right',
      });
    }
  }, [error]);

  return (
    <Wrapper>
      <MainTitlePage>{t('UI.staff')}</MainTitlePage>
      <StaffSortableTable />
      <PaginationWrapper>
        <TotalCountUser>
          {t('UI.totalUsers', {
            visibleUsers: list.length,
            totalCount: count,
          })}
        </TotalCountUser>
        {count > staffListOffset && (
          <Pagination
            count={Math.ceil(count / staffListOffset)}
            page={pageNumber}
            defaultPage={DEFAULT_PAGE_NUMBER}
            onChange={changePage}
          />
        )}
      </PaginationWrapper>
    </Wrapper>
  );
};
